import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { field: String }

  get isModal() {
    return this.element.classList.contains("ai-rewrite-modal__overlay")
  }

  connect() {
    if (!this.isModal) return

    document.body.style.overflow = "hidden"
    this._onKeydown = (event) => {
      if (event.key === "Escape") this.close()
    }
    window.addEventListener("keydown", this._onKeydown)

    this._onFrameLoad = () => this.syncEditPageButton()
    const resultFrame = document.getElementById("ai_rewrite_result")
    if (resultFrame) {
      resultFrame.addEventListener("turbo:frame-load", this._onFrameLoad)
    }

    this.syncEditPageButton()
  }

  request(event) {
    const textarea = document.getElementById(`member_profile_${this.fieldValue}`)
    if (!textarea) return

    const link = event.currentTarget
    const url = new URL(link.href)
    url.searchParams.set("original_text", textarea.value)
    link.href = url.toString()
  }

  save() {
    const rewriteEl = this.element.querySelector(".ai-rewrite-modal__textarea.is-rewrite")
    if (!rewriteEl) return

    const text = rewriteEl.textContent.trim()
    const textarea = document.getElementById(`member_profile_${this.fieldValue}`)
    if (textarea) {
      textarea.value = text
      textarea.dispatchEvent(new Event("input", { bubbles: true }))
    }
    this.close()
  }

  syncEditPageButton() {
    const editButton = this.findEditPageButton()
    if (!editButton) return

    const labelWrap = editButton.closest(".mypage-profile-section__form-label-wrap")
    if (!labelWrap) return

    this.syncRemainingCount(editButton)

    const cooldownEl = this.element.querySelector(".ai-rewrite-modal__cooldown")
    if (cooldownEl) {
      editButton.classList.add("is-disabled")

      if (!labelWrap.querySelector(".mypage-profile-section__form-ai-rewrite-cooldown")) {
        const cooldownSpan = document.createElement("span")
        cooldownSpan.className = "mypage-profile-section__form-ai-rewrite-cooldown"
        cooldownSpan.textContent = cooldownEl.textContent
        labelWrap.insertBefore(cooldownSpan, editButton)
      }
    }
  }

  syncRemainingCount(editButton) {
    const modalButton = this.element.querySelector(".ai-rewrite-modal__re-rewrite-button")
    if (!modalButton) return

    const match = modalButton.textContent.match(/残り(\d+)回/)
    if (!match) return

    const remaining = match[1]
    for (const node of editButton.childNodes) {
      if (node.nodeType === Node.TEXT_NODE && /残り\d+回/.test(node.textContent)) {
        node.textContent = node.textContent.replace(/残り\d+回/, `残り${remaining}回`)
        return
      }
    }
  }

  findEditPageButton() {
    const links = document.querySelectorAll(".mypage-profile-section__form-ai-rewrite-button")
    for (const link of links) {
      if (link.href && link.href.includes(`field=${this.fieldValue}`)) {
        return link
      }
    }
    return null
  }

  close() {
    document.body.style.overflow = ""
    window.removeEventListener("keydown", this._onKeydown)
    const resultFrame = document.getElementById("ai_rewrite_result")
    if (resultFrame) {
      resultFrame.removeEventListener("turbo:frame-load", this._onFrameLoad)
    }
    const frame = document.getElementById("ai_rewrite_modal")
    if (frame) frame.innerHTML = ""
  }

  closeOnOverlay(event) {
    if (event.target === this.element) {
      this.close()
    }
  }

  disconnect() {
    if (!this.isModal) return

    document.body.style.overflow = ""
    window.removeEventListener("keydown", this._onKeydown)
  }
}
